//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LiquidationHelper
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x931cf9F135a0cd54922256aAc33ca6151Ed735d3)
 */
export const liquidationHelperAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_repository', internalType: 'address', type: 'address' },
      {
        name: '_chainlinkPriceProvider',
        internalType: 'address',
        type: 'address',
      },
      { name: '_lens', internalType: 'address', type: 'address' },
      { name: '_exchangeProxy', internalType: 'address', type: 'address' },
      {
        name: '_magicians',
        internalType: 'struct LiquidationHelper.MagicianConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'asset', internalType: 'address', type: 'address' },
          {
            name: 'magician',
            internalType: 'contract IMagician',
            type: 'address',
          },
        ],
      },
      {
        name: '_swappers',
        internalType: 'struct LiquidationHelper.SwapperConfig[]',
        type: 'tuple[]',
        components: [
          {
            name: 'provider',
            internalType: 'contract IPriceProvider',
            type: 'address',
          },
          {
            name: 'swapper',
            internalType: 'contract ISwapper',
            type: 'address',
          },
        ],
      },
      { name: '_baseCost', internalType: 'uint256', type: 'uint256' },
      {
        name: '_tokensReceiver',
        internalType: 'address payable',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'AddressZero' },
  { type: 'error', inputs: [], name: 'ApprovalFailed' },
  { type: 'error', inputs: [], name: 'FallbackPriceProviderNotSet' },
  { type: 'error', inputs: [], name: 'InvalidChainlinkProviders' },
  { type: 'error', inputs: [], name: 'InvalidMagicianConfig' },
  { type: 'error', inputs: [], name: 'InvalidScenario' },
  { type: 'error', inputs: [], name: 'InvalidSiloLens' },
  { type: 'error', inputs: [], name: 'InvalidSiloRepository' },
  { type: 'error', inputs: [], name: 'InvalidSwapperConfig' },
  { type: 'error', inputs: [], name: 'InvalidTowardsAssetConvertion' },
  {
    type: 'error',
    inputs: [{ name: 'inTheRed', internalType: 'uint256', type: 'uint256' }],
    name: 'LiquidationNotProfitable',
  },
  { type: 'error', inputs: [], name: 'MagicianNotFound' },
  { type: 'error', inputs: [], name: 'Max0xSwapsIs2' },
  { type: 'error', inputs: [], name: 'NotSilo' },
  { type: 'error', inputs: [], name: 'PriceProviderNotFound' },
  { type: 'error', inputs: [], name: 'RepayApprovalFailed' },
  { type: 'error', inputs: [], name: 'RepayFailed' },
  { type: 'error', inputs: [], name: 'SwapAmountInFailed' },
  { type: 'error', inputs: [], name: 'SwapAmountOutFailed' },
  { type: 'error', inputs: [], name: 'SwapperNotFound' },
  { type: 'error', inputs: [], name: 'TargetNotExchangeProxy' },
  { type: 'error', inputs: [], name: 'UsersMustMatchSilos' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'sellToken',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'buyToken',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'boughtAmount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BoughtTokens',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'silo', internalType: 'address', type: 'address', indexed: true },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'earned',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'estimatedEarnings',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'LiquidationExecuted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'magician',
        internalType: 'contract IMagician',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'MagicianConfigured',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'provider',
        internalType: 'contract IPriceProvider',
        type: 'address',
        indexed: false,
      },
      {
        name: 'swapper',
        internalType: 'contract ISwapper',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'SwapperConfigured',
  },
  {
    type: 'function',
    inputs: [],
    name: 'CHAINLINK_PRICE_PROVIDER',
    outputs: [
      {
        name: '',
        internalType: 'contract ChainlinkV3PriceProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'EXCHANGE_PROXY',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'LENS',
    outputs: [{ name: '', internalType: 'contract SiloLens', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'PRICE_PROVIDERS_REPOSITORY',
    outputs: [
      {
        name: '',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'QUOTE_TOKEN',
    outputs: [{ name: '', internalType: 'contract IERC20', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'SILO_REPOSITORY',
    outputs: [
      { name: '', internalType: 'contract ISiloRepository', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'TOKENS_RECEIVER',
    outputs: [{ name: '', internalType: 'address payable', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_users', internalType: 'address[]', type: 'address[]' },
      { name: '_silos', internalType: 'contract ISilo[]', type: 'address[]' },
    ],
    name: 'checkDebt',
    outputs: [{ name: '', internalType: 'bool[]', type: 'bool[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_users', internalType: 'address[]', type: 'address[]' },
      { name: '_silos', internalType: 'contract ISilo[]', type: 'address[]' },
    ],
    name: 'checkSolvency',
    outputs: [{ name: '', internalType: 'bool[]', type: 'bool[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_gasStart', internalType: 'uint256', type: 'uint256' },
      { name: '_earnedEth', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ensureTxIsProfitable',
    outputs: [{ name: 'txFee', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_user', internalType: 'address', type: 'address' },
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
      {
        name: '_scenario',
        internalType: 'enum ILiquidationHelper.LiquidationScenario',
        type: 'uint8',
      },
      {
        name: '_swapsInputs0x',
        internalType: 'struct ZeroExSwap.SwapInput0x[]',
        type: 'tuple[]',
        components: [
          { name: 'sellToken', internalType: 'address', type: 'address' },
          { name: 'allowanceTarget', internalType: 'address', type: 'address' },
          { name: 'swapCallData', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'executeLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_sellToken', internalType: 'address', type: 'address' },
      { name: '_spender', internalType: 'address', type: 'address' },
      { name: '_swapCallData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'fillQuote',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'findPriceProvider',
    outputs: [
      {
        name: 'priceProvider',
        internalType: 'contract IPriceProvider',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'liquidationSupported',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'magicians',
    outputs: [
      { name: '', internalType: 'contract IMagician', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_magicians',
        internalType: 'struct LiquidationHelper.MagicianConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'asset', internalType: 'address', type: 'address' },
          {
            name: 'magician',
            internalType: 'contract IMagician',
            type: 'address',
          },
        ],
      },
    ],
    name: 'setMagicians',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_swappers',
        internalType: 'struct LiquidationHelper.SwapperConfig[]',
        type: 'tuple[]',
        components: [
          {
            name: 'provider',
            internalType: 'contract IPriceProvider',
            type: 'address',
          },
          {
            name: 'swapper',
            internalType: 'contract ISwapper',
            type: 'address',
          },
        ],
      },
    ],
    name: 'setSwappers',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_user', internalType: 'address', type: 'address' },
      { name: '_assets', internalType: 'address[]', type: 'address[]' },
      {
        name: '_receivedCollaterals',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
      {
        name: '_shareAmountsToRepaid',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
      { name: '_flashReceiverData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'siloLiquidationCallback',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'contract IPriceProvider', type: 'address' },
    ],
    name: 'swappers',
    outputs: [{ name: '', internalType: 'contract ISwapper', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x931cf9F135a0cd54922256aAc33ca6151Ed735d3)
 */
export const liquidationHelperAddress = {
  1: '0x931cf9F135a0cd54922256aAc33ca6151Ed735d3',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x931cf9F135a0cd54922256aAc33ca6151Ed735d3)
 */
export const liquidationHelperConfig = {
  address: liquidationHelperAddress,
  abi: liquidationHelperAbi,
} as const
